import styles from './SocialLink.module.css';

interface ISocialLink {
  id: string;
  href: string;
  image: string;
  alt: string;
}

export const SocialLink = ({ id, image, href, alt }: ISocialLink) => {
  return (
    <a id={id} href={href} target="_blank" rel="noreferrer">
      <img className={styles.socialIcon} src={image} alt={alt} />
    </a>
  );
};
